import styled from "styled-components";

// Styles
export const NoPrescriptionsDiv = styled.div`
  margin: 10px auto;
  padding: 16px;
  width: 100%;
  max-width: 860px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const NoPrescriptionsText = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #808080;
`;
